import { Plan } from 'api/savings-plans';
import { SavingsPlan } from 'interfaces/customer';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

// Keep for backward compatibility with existing components
export const SavingPlanValues = {
  None: 'none',
  Clever: 'clever',
  Premium: 'premium',
} as const;

export type SavingPlanTypes = (typeof SavingPlanValues)[keyof typeof SavingPlanValues];

interface SavingPlanState {
  _hasHydrated: boolean;
  activePlan: Plan | SavingsPlan | null;
  availablePlans: Plan[];
  isPlanFromCustomer: boolean;
  clearActivePlan: () => void;
  setActivePlan: (plan: Plan | null) => void;
  setAvailablePlans: (plans: Plan[]) => void;
  setCustomerPlan: (plan: SavingsPlan | null) => void;
  setHasHydrated: (state: boolean) => void;
}

export const useSavingPlanStore = create<SavingPlanState>()(
  persist(
    (set) => ({
      _hasHydrated: false,
      activePlan: null,
      availablePlans: [],
      isPlanFromCustomer: false,
      clearActivePlan: () => set({ activePlan: null, isPlanFromCustomer: false }),
      setActivePlan: (plan) => set({ activePlan: plan, isPlanFromCustomer: false }),
      setAvailablePlans: (plans) => set({ availablePlans: plans }),
      setCustomerPlan: (plan) => set({ activePlan: plan, isPlanFromCustomer: !!plan }),
      setHasHydrated: (state) => set({ _hasHydrated: state }),
    }),
    {
      name: 'pd:saving-plan-store',
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => state?.setHasHydrated(true),
    }
  )
);
